import React, { Component } from 'react'

import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../common/Modal';

import SimpleDropdown from '../../common/SimpleDropdown';
class ResetPassword extends Component{
  constructor(props){
    super(props)
  }

toggleResetpasswordDialog = () =>{
  this.props.setToggleResetpasswordDialog(false);
}

Resetpassword = ()=>{
  this.props.resetPassword()
}

selectUser = (event) =>{
 this.props.setUsermail(event);
}
  render(){
    return(
      <Modal
        show={this.props.showResetPasswordModal}
        onClose={this.toggleResetpasswordDialog}
        bsClass="delete-group-model"
      >
        <ModalHeader title={this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.heading)} />
        <ModalBody>
        <p>{this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.description)}</p>
          <div>
          <label>{this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.emailLabel)}</label>
          <SimpleDropdown
          options={this.props.userDataReset}
          _onChange={this.selectUser}
          defaultValue ={this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.dropDownLabel)}
          value={this.props._value}
          optionTextSelector="email"
          valueSelector="email"  />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="delete-group-model--body">
            <div className="gdocs-float-right gdocs-mleft-15">
            <button className="gdocs-btn-delete" onClick={this.toggleResetpasswordDialog}>
               {this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.cancelLabel)}
            </button>
            </div>
            <div className="gdocs-float-right">
            <button className="gdocs-btn-primary" onClick={this.Resetpassword}>
               {this.props.translations(this.props.pageJson.static_text_resetPasswordAdmin.submitLabel)}
            </button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    )}

  }

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/Admin/CustomerDetail/ResetPassword.js